<template>
<section :id="id" class="offer">
    <v-row class="mb-5">
        <v-col style="display: flex; align-items: center" :align="isMobile ? 'center' : 'left'" :class="{ 'justify-center flex-column': isMobile }">
            <div>
                <v-icon :style="{
              fontSize: icon_size,
              height: icon_size,
              width: icon_size,
            }" class="icon">
                    <slot name="icon"></slot>
                </v-icon>
            </div>

            <h3 class="header" :class="{ 'ml-5': !isMobile }" :style="isMobile ? 'margin-top:10px' : ''">
                <slot name="header"></slot>
            </h3>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <div class="description" :class="{ 'text-center': isMobile }">
                <slot name="description"></slot>
            </div>
        </v-col>
        <v-col v-if="haveSketch" :style="isMobile ? 'min-width: 100%' : ''">
            <slot name="sketch"></slot>
        </v-col>
    </v-row>
    <v-row>
        <slot name="images"></slot>
    </v-row>
</section>
</template>

<script>
export default {
    data() {
        return {
            icon_size: 80,
        };
    },
    props: {
        id: String,
        haveSketch: Boolean
    },
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        },
    },
};
</script>

<style lang="scss">
.offer {
    color: #fff;
    margin-bottom: 50px;
    font-size: 1.3em;
    //text-shadow: rgb(0 0 0) 0px 0px 4px;

    @media only screen and (max-width: 600px) {
        font-size: 0.8em;
    }

    .icon {
        fill: #2c5aa0;
        background: #fff;
        border-radius: 100%;
        border: 5px solid #fff;
        font-size: 70px;
        color: #2c5aa0;
    }

    .header {
        font-size: 2em;
        display: inline-block;
    }
}
</style>
